<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Inquiry Requests'
                    : 'Deleted Inquiry Requests'
                "
              ></h3>
            </v-card-title>
            <v-card-text>
              <v-tabs v-model="activeTab" color="#e60040" @change="onTabChange">
                <v-tab>Inquiree</v-tab>
                <v-tab>Inquirer</v-tab>
              </v-tabs>
              <v-row class="mt-2">
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    hide-details="auto"
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3" v-if="activeTab === 0">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    hide-details="auto"
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3" v-if="activeTab === 0">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    hide-details="auto"
                    v-model="filter.status"
                    :items="inquiryStatuses"
                    clearable
                    @click:clear="(filter.status = null), (page = 1)"
                    label="Inquiry Status"
                    @input="getData"
                    prepend-inner-icon="mdi-check-circle"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3" v-if="activeTab === 0">
                  <v-autocomplete
                    solo
                    rounded
                    hide-details="auto"
                    ref="user"
                    v-model="filter.user_id"
                    :items="usersItems"
                    label="Marketing Executive"
                    @input="(page = 1), getData()"
                    @click:clear="(filter.user_id = null), (page = 1)"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3" v-if="activeTab === 0">
                  <v-autocomplete
                    solo
                    rounded
                    hide-details="auto"
                    ref="position"
                    v-model="filter.position_id"
                    :items="positionItems"
                    label="Position"
                    @input="(page = 1), getData()"
                    @click:clear="(filter.position_id = null), (page = 1)"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <!-- Month Year -->
                <v-col sm="3">
                  <v-menu
                    v-model="month_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        hide-details="auto"
                        v-model="filter.month_year"
                        label="Year - Month"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="filter.month_year = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.month_year"
                      type="month"
                      @input="
                        getData();
                        month_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Month Year -->
                <!-- Start date -->
                <v-col sm="3">
                  <v-menu
                    v-model="start_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        hide-details="auto"
                        v-model="filter.start_date"
                        label="Start Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="filter.start_date = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.start_date"
                      @input="
                        getData();
                        start_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Start date -->
                <!-- End date -->
                <v-col sm="3">
                  <v-menu
                    v-model="end_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        hide-details="auto"
                        v-model="filter.end_date"
                        label="End Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="filter.end_date = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.end_date"
                      @input="
                        getData();
                        end_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /End date -->
                <v-col v-if="activeTab === 0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        rounded
                        depressed
                        color="error"
                        class="my-auto"
                        @click="deleteAll(inquiry_requests.id)"
                        style="width: 90px; height: 50px"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Delete all Store</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Active inquirer filter banner -->
      <v-row v-if="activeTab === 0 && selectedInquirerName">
        <v-col md="12">
          <div
            class="d-flex align-center"
            style="background-color: #f5f5f5; border-radius: 24px; overflow: hidden; min-height: 44px; border: 1px solid #e0e0e0;"
          >
            <span class="pl-4 flex-grow-1 py-2" style="color: #37474f;">
              <v-icon left small color="#e60040">mdi-filter</v-icon>
              Showing inquirees for: <strong>{{ selectedInquirerName }}</strong>
            </span>
            <v-btn
              color="#e60040"
              dark
              depressed
              style="border-radius: 0 24px 24px 0; min-height: 44px;"
              @click="clearInquirerFilter"
            >
              <v-icon left small>mdi-close-circle</v-icon>
              <span class="font-weight-bold">Show All Inquirees</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="activeTab === 0 && inquiry_requests.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                large
                class="primary"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>

              <!-- Inquiree Tab Table (existing) -->
              <v-simple-table v-else-if="activeTab === 0" class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">
                        Inquirer Name
                      </th>
                      <th class="text-left" style="min-width: none">
                        Inquirer Phone
                      </th>
                      <th class="text-left">Inquiry Status</th>
                      <th class="text-left">Is Booster</th>
                      <th class="text-left">Sale Punched</th>
                      <th class="text-left">Sale Invoice No</th>
                      <th class="text-left">Rewarded Points</th>
                      <th class="text-left">Reminder Date</th>
                      <th class="text-left">Created At</th>
                      <th class="text-left">Created By Name</th>
                      <th class="text-left">Created By Phone</th>
                      <th class="text-left">Created By Position</th>
                      <th class="text-left">Billing Store</th>
                      <th class="text-left">Billing Amount</th>
                      <th class="text-left">Billing Date</th>
                      <th class="text-left">Billing Created By</th>
                      <th class="text-left">Total Billing Count</th>
                      <th class="text-left">Total Billing Amount</th>
                      <th class="text-left">Image</th>
                    </tr>
                  </thead>
                  <tbody v-if="inquiry_requests.length != 0">
                    <tr
                      v-for="(inquiry_request, i) in inquiry_requests"
                      :key="`inquiry_request_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': inquiry_requests.length - 1 == i,
                      }"
                    >
                      <td>
                        <input
                          type="checkbox"
                          v-model="inquiry_request.is_selected"
                        />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="inquiry_request.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Gift is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="inquiry_request.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Gift is InActive</span>
                        </v-tooltip>
                      </td>

                      <td>{{ inquiry_request.inquirer_first_name || "" }}</td>
                      <td>{{ inquiry_request.inquirer_phone || "" }}</td>
                      <td>
                        <v-chip
                          small
                          outlined
                          :color="getInquiryStatusColor(inquiry_request.status)"
                          class="font-weight-medium"
                        >
                          {{ getInquiryStatusLabel(inquiry_request.status) }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip
                          small
                          :color="inquiry_request.user && inquiry_request.user.is_boosted_driver == 1 ? 'primary' : 'grey'"
                          text-color="white"
                        >
                          {{ inquiry_request.user && inquiry_request.user.is_boosted_driver == 1 ? "YES" : "NO" }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip
                          small
                          :color="inquiry_request.sale_punched_user == 1 ? 'success' : 'grey'"
                          text-color="white"
                        >
                          {{ inquiry_request.sale_punched_user == 1 ? "YES" : "NO" }}
                        </v-chip>
                      </td>
                      <td>
                        {{
                          inquiry_request.sale && inquiry_request.sale.invoice_no
                            ? inquiry_request.sale.invoice_no
                            : "-"
                        }}
                      </td>
                      <td>
                        {{ inquiry_request.rewarded_point || "0" }}
                      </td>
                      <td style="min-width: 130px">
                        {{ inquiry_request.reminder_date || "" }}
                      </td>
                      <td style="min-width: 130px">
                        {{ formatDateTime(inquiry_request.created_at) }}
                      </td>
                      <td>
                        {{
                          inquiry_request.created_by
                            ? inquiry_request.created_by.user_name ||
                              inquiry_request.created_by.first_name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          inquiry_request.created_by
                            ? inquiry_request.created_by.phone
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          inquiry_request.created_by &&
                          inquiry_request.created_by.position
                            ? inquiry_request.created_by.position.name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          inquiry_request.sale && inquiry_request.sale.store
                            ? inquiry_request.sale.store.store_location
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          inquiry_request.sale
                            ? inquiry_request.sale.amount
                            : ""
                        }}
                      </td>
                      <td style="min-width: 130px">
                        {{
                          inquiry_request.sale
                            ? formatDateTime(inquiry_request.sale.created_at)
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          inquiry_request.sale &&
                          inquiry_request.sale.created_by
                            ? `${
                                inquiry_request.sale.created_by.first_name || ""
                              } ${
                                inquiry_request.sale.created_by.last_name || ""
                              }`.trim()
                            : ""
                        }}
                      </td>
                      <td>
                        {{ inquiry_request.no_of_sales || 0 }}
                      </td>
                      <td>
                        {{ inquiry_request.total_sales_amount || 0 }}
                      </td>
                      <td>
                        <v-btn
                          icon
                          text
                          :href="`${mediaUrl}${inquiry_request.image_path}`"
                          color="primary"
                          target="_blank"
                        >
                          <v-icon>mdi-file-document-edit-outline</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="22" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <!-- Inquirer Tab Table -->
              <v-simple-table v-else class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr. No.</th>
                      <th class="text-left">Inquirer Name</th>
                      <th class="text-left">Inquirer Phone</th>
                      <th class="text-left">Position</th>
                      <th class="text-left">Total Inquirees</th>
                      <th class="text-left">Total Pending</th>
                      <th class="text-left">Total Completed</th>
                      <th class="text-left">Total Rejected</th>
                      <th class="text-left">Actions</th>
                    </tr>
                  </thead>
                  <tbody v-if="inquirerSummaryList && inquirerSummaryList.length != 0">
                    <tr
                      v-for="(group, i) in inquirerSummaryList"
                      :key="`inquirer_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': inquirerSummaryList.length - 1 == i,
                      }"
                    >
                      <td>{{ i + 1 }}</td>
                      <td>
                        {{
                          group.inquirer
                            ? group.inquirer.user_name || group.inquirer.first_name
                            : ""
                        }}
                      </td>
                      <td>{{ group.inquirer ? group.inquirer.phone : "" }}</td>
                      <td>
                        {{
                          group.inquirer && group.inquirer.position
                            ? group.inquirer.position.name
                            : ""
                        }}
                      </td>
                      <td>
                        <v-chip small color="blue darken-1" text-color="white">
                          {{ group.total_count }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip small outlined color="#F57C00">
                          {{ group.pending_count }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip small outlined color="#388E3C">
                          {{ group.completed_count }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip small outlined color="#D32F2F">
                          {{ group.rejected_count }}
                        </v-chip>
                      </td>
                      <td>
                        <v-btn
                          small
                          color="#e60040"
                          dark
                          rounded
                          @click="viewInquirees(group)"
                        >
                          <v-icon left small>mdi-account-group</v-icon>
                          View Inquirees
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="9" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-pagination
                v-if="activeTab === 0"
                rounded
                v-model="page"
                :length="paginationLength"
              ></v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_inquiry_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Gift deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_inquiry_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_inquiry_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Gift restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_inquiry_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "inquiry_requestsPage",
  data() {
    return {
      activeTab: 0,
      filter: {
        search_keyword: "",
        is_active: "",
        status: "",
        is_selected: false,
        user_id: "",
        position_id: "",
        month_year: "",
        start_date: "",
        end_date: "",
      },
      usersItems: [],
      positionItems: [],
      inquiry_requests: [],
      inquirerSummaryList: [],
      selectedInquirerName: null,
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      inquiryStatuses: [
        { id: 0, text: "All Status", value: "" },
        { id: 1, text: "Pending", value: "0" },
        { id: 2, text: "Completed", value: "1" },
        { id: 3, text: "Discarded", value: "2" },
      ],
      ExportGiftTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      is_restored_inquiry_request: false,
      isExcelloading: false,
      delete_inquiry_request: false,
      is_deleted_inquiry_request: false,
      is_select_all: false,
      isDeleteAll: false,
      month_menu: false,
      start_menu: false,
      end_menu: false,
    };
  },
  watch: {
    page() {
      if (this.activeTab === 0) this.getData();
    },
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    onTabChange() {
      this.page = 1;
      this.selectedInquirerName = null;
      this.getData();
    },
    viewInquirees(group) {
      this.filter.user_id = group.user_id;
      this.selectedInquirerName = group.inquirer
        ? group.inquirer.user_name || group.inquirer.first_name
        : null;
      this.page = 1;
      this.activeTab = 0;
      this.getData();
    },
    clearInquirerFilter() {
      this.filter.user_id = null;
      this.selectedInquirerName = null;
      this.page = 1;
      this.getData();
    },
    async getMasters() {
      await axios
        .get(`inquiry_requests/masters`)
        .then((masters) => {
          masters = masters.data;
          //User
          masters.users.forEach((user) => {
            this.usersItems.push({
              id: user.id,
              text: user.first_name,
              value: user.id,
            });
          });
          //User
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async getData() {
      this.isLoading = true;

      if (this.activeTab === 1) {
        await this.getInquirerSummary();
        this.isLoading = false;
        return;
      }

      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.status = this.filter.status
        ? this.filter.status
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state = this.filter.state ? this.filter.state : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.store_id = this.filter.store_id ? this.filter.store_id : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&role_id=2" +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&status=" +
        this.filter.status +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&position_id=" +
        this.filter.position_id +
        "&store_id=" +
        this.filter.store_id +
        "&state=" +
        this.filter.state +
        "&city=" +
        this.filter.city +
        "&month_year=" +
        this.filter.month_year +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`inquiry_requests?${query}`)
        .then((response) => {
          this.inquiry_requests = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    async getInquirerSummary() {
      const searchKeyword = this.filter.search_keyword || "";
      const monthYear = this.filter.month_year || "";
      const startDate = this.filter.start_date || "";
      const endDate = this.filter.end_date || "";

      let query =
        "search_keyword=" + searchKeyword +
        "&month_year=" + monthYear +
        "&start_date=" + startDate +
        "&end_date=" + endDate;

      await axios
        .get(`inquiry_requests/inquirer_summary?${query}`)
        .then((response) => {
          this.inquirerSummaryList = response.data.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //Generate Excel
    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.status = this.filter.status
        ? this.filter.status
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state = this.filter.state ? this.filter.state : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.store_id = this.filter.store_id ? this.filter.store_id : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      let response = [];
      let query =
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&status=" +
        this.filter.status +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&position_id=" +
        this.filter.position_id +
        "&store_id=" +
        this.filter.store_id +
        "&state=" +
        this.filter.state +
        "&city=" +
        this.filter.city +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&month_year=" +
        this.filter.month_year +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/inquiry_requests/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
    async Delete_this(id) {
      this.delete_inquiry_request = true;
      await axios
        .post(`/inquiry_requests/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_inquiry_request = false;
          this.is_deleted_inquiry_request = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectAll() {
      console.log(this.is_select_all);
      this.inquiry_requests.forEach((inquiry_requests) => {
        inquiry_requests.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      let deleteallIds = [];
      this.inquiry_requests.forEach((inquiry_request) => {
        if (inquiry_request.is_selected) deleteallIds.push(inquiry_request);
      });
      await axios
        .post("/inquiry_requests/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      this.isDeleteAll = false;
    },
    async Restore_this(id) {
      this.restore_inquiry_request = true;
      await axios
        .post(`/inquiry_requests/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_inquiry_request = false;
          this.is_restored_inquiry_request = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },
    formatDateTime(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },
    getInquiryStatusLabel(status) {
      const statuses = {
        0: 'Pending',
        1: 'Completed',
        2: 'Discarded',
      };
      return statuses[status] || 'Unknown';
    },
    getInquiryStatusColor(status) {
      const colors = {
        0: '#F57C00',      // Orange - Pending
        1: '#388E3C',      // Green - Completed
        2: '#D32F2F',      // Red - Discarded
      };
      return colors[status] || '#757575';
    },
  },
};
</script>
